import useFetchAuthImage from "../../../../../Hooks/useFetchAuthImage";
import { Skeleton } from "@mui/material";

const ImageSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width="100%"
      height={190}
      animation="wave"
      sx={{ borderTopLeftRadius: 16, borderTopRightRadius: 16 }}
    />
  );
};

const ChatbotVenueCard = ({ data }) => {
  const imagePath = data.place_id
    ? `/services/projectmanagement/api/ai-bot/chat/image-proxy?placeId=${data.place_id}`
    : data.photo_reference
      ? `/services/projectmanagement/api/ai-bot/chat/image-proxy?photoReference=${data.photo_reference}`
      : null;
  const { data: imageData, loading } = useFetchAuthImage({ path: imagePath });

  const handleClick = () => {
    if (data.website) {
      window.open(data.website, "_blank");
    }
  };

  return (
    <div className="chatbot-venue-card shadow" onClick={handleClick}>
      {imagePath && (
        <div className="chatbot-venue-card__image">
          {loading ? (
            <ImageSkeleton />
          ) : (
            <img src={imageData} alt={data.name} />
          )}
        </div>
      )}
      <div className="chatbot-venue-card__content">
        <h3>{data.name}</h3>
        {data.location && (
          <p>
            <span className="label">Location:</span> {data.location}
          </p>
        )}
        {data.type && (
          <p>
            <span className="label">Type:</span> {data.type}
          </p>
        )}
        {data.price_range && (
          <p>
            <span className="label">Price Range:</span> {data.price_range}
          </p>
        )}
        {data?.other_fields?.map((field, idx) => (
          <p key={idx}>
            <span className="label">{field.name}:</span> {field.value}
          </p>
        ))}
      </div>
    </div>
  );
};
export default ChatbotVenueCard;
